import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../config.service';
import { Observable } from 'rxjs';
import {
  AbsenceConfirmationItem,
  TaskResult,
} from '../../models/client-models';
import {
  AbsencePlanerUserList,
  AbsencePlanerUserParameter,
} from '../../models/client-models';

const ABSENCE_ENDPOINT = 'absencePlaner';

@Injectable({
  providedIn: 'root',
})
export class AbsencePlanerBackendService {
  constructor(private http: HttpClient) {}

  public getListOfAbsences(
    parameters: AbsencePlanerUserParameter
  ): Observable<AbsencePlanerUserList[]> {
    return this.http.get<AbsencePlanerUserList[]>(
      AppConfig.settings.backend.url +
        ABSENCE_ENDPOINT +
        '/auth?ChronoUserID=' +
        parameters.chronoUserID +
        '&PersonalID=' +
        parameters.personalID +
        '&Grouping=' +
        parameters.grouping +
        '&Filter=' +
        parameters.filter +
        '&FilterID=' +
        parameters.filterID +
        '&ShowFuture=true'
    );
  }

  public getListOfAbsencesToConfirm(
    chronoUserID: number,
    allAbsences: boolean
  ): Observable<AbsenceConfirmationItem[]> {
    if (allAbsences) {
      return this.http.get<AbsenceConfirmationItem[]>(
        AppConfig.settings.backend.url +
          ABSENCE_ENDPOINT +
          '/requestAll?AdmiaUserID=' +
          chronoUserID
      );
    } else {
      return this.http.get<AbsenceConfirmationItem[]>(
        AppConfig.settings.backend.url +
          ABSENCE_ENDPOINT +
          '/request?AdmiaUserID=' +
          chronoUserID
      );
    }
  }

  public sendAbsenceRequestDecision(
    parameter: AbsenceConfirmationItem
  ): Observable<TaskResult> {
    return this.http.post<TaskResult>(
      AppConfig.settings.backend.url + ABSENCE_ENDPOINT + '/request',
      parameter
    );
  }
}
